module.exports = __webpack_public_path__ + "static/media/loupe.b9fd64fd.svg";